/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext } from "react";
import { Button } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DocumentEditContext } from "cms/documents/document-selector/context/document-edit-context";

const DocumentDialogBottomActions = () => {
    const {
        saveDocument,
        hasChanges,
        setHasChanges,
        isFieldValid
    } = useContext(DocumentEditContext);

    const handleSave = () => {
        saveDocument();
        setHasChanges(false);
    };

    return (
        <div className="simplicity-doc-selector-window-footer">

            <Button
                variant="contained"
                color="primary"
                onClick={handleSave}
                disabled={!hasChanges || !isFieldValid}
                startIcon={<FontAwesomeIcon icon="fa-regular fa-check" />}
            >
                Save changes
            </Button>
        </div>
    );
};

export { DocumentDialogBottomActions };
